import { render } from "./RegistrationComplete.vue?vue&type=template&id=f2326fac&scoped=true"
import script from "./RegistrationComplete.vue?vue&type=script&lang=js"
export * from "./RegistrationComplete.vue?vue&type=script&lang=js"

import "./RegistrationComplete.vue?vue&type=style&index=0&id=f2326fac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2326fac"]])

export default __exports__